<script lang="ts" setup>
import type { IProps } from './MsFoundationItem.types'
const props = defineProps<IProps>()
const { isMobile } = useBSBreakpoints()

const itemBgImage = computed(() => isMobile.value ? props.item.image.urlMobile : props.item.image.url)

</script>

<template>
  <div class="ms-foundation-item">
    <div
      class="ms-foundation-item__top"
      :style="`background-image: url(${itemBgImage})`"
    >
      <img
        v-if="item.icon"
        :src="item.icon.url"
        :alt="item.icon.alternative"
        class="ms-foundation-item__icon"
      >
    </div>

    <h3 class="ms-foundation-item__heading">
      {{ item.title }}
    </h3>

    <div
      class="ms-foundation-item__text"
      v-html="item.text"
    />
  </div>
</template>

<style lang="scss" scoped>
.ms-foundation-item {
  display: flex;
  flex: 1 1 45%;
  flex-direction: column;

  &__top {
    position: relative;
    min-height: 22rem;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    border-top-left-radius: 1.6rem;
    border-top-right-radius: 1.6rem;
  }

  &__icon {
    position: absolute;
    right: 3.2rem;
    bottom: -3.6rem;
    max-width: 7.2rem;
  }

  &__heading {
    @include h9;
    display: flex;
    align-items: center;
    min-height: 9.6rem;
    padding: 0.8rem 11rem 0.8rem 2.4rem;
    background-color: #C2D6FB;
  }

  &__text {
    @include body-1-medium;
    height: 100%;
    padding: 2.4rem;
    border: 1px solid $gray-200;
    border-bottom-right-radius: 1.6rem;
    border-bottom-left-radius: 1.6rem;
  }

  @include atM {
    &__icon {
      bottom: -4.8rem;
      max-width: 9.6rem;
    }

    &__text {
      @include h10;
      padding: 3.2rem;
    }

    &__heading {
      min-height: 9.6rem;
      padding: 0.8rem 11rem 0.8rem 3.2rem;
    }
  }
}
</style>
